import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React, {
  Fragment,
  type ReactElement,
  type FunctionComponent,
} from 'react';

import { PAGE_VALIDATION_ERROR } from 'src/app/shared/constants/errorMessages';
import ConnectionError from 'src/app/v1/views/components/ConnectionError';
import PageErrorMessage from 'src/app/v1/views/shared/PageErrorMessage';

import translations from './.vocab';

interface Props {
  title: string;
  children: ReactElement;
  errorType?: string;
}

export const BasicPageLayout: FunctionComponent<Props> = ({
  children,
  title,
  errorType,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box marginBottom="xxlarge" marginTop="large" paddingX="gutter">
      <ContentBlock>
        <Stack space="large">
          <Heading level="2">{title}</Heading>
          <Columns space="small" collapseBelow="tablet">
            <Column>
              {children}

              <PageErrorMessage hasError={Boolean(errorType)}>
                {errorType === PAGE_VALIDATION_ERROR ? (
                  <Text>{t('basic-page-layout-error')}</Text>
                ) : (
                  <ConnectionError errorType={errorType} />
                )}
              </PageErrorMessage>
            </Column>
            <Column width="1/3">
              <Fragment />
            </Column>
          </Columns>
        </Stack>
      </ContentBlock>
    </Box>
  );
};
